import { Component } from '@angular/core';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';

@Component({
  selector: 'app-banner-autoinvest',
  standalone: true,
  imports: [
    BtnLinkComponent
  ],
  templateUrl: './banner-autoinvest.component.html',
  styleUrl: './banner-autoinvest.component.scss'
})
export class BannerAutoinvestComponent {

}
